import {useState} from 'react';
import {Link} from 'react-router-dom';
import {Grid, Container, Header, Image, Message} from 'semantic-ui-react';

import httpClient from 'httpClient';
import wordpressIconDark from 'static/wordpress_icon_dark.png';

import {wordpressSubdomain} from '../Common/sharedElements';

import WordPressCreationForm from './WordPressCreationForm';

import styles from './WordPressCreation.module.scss';

const WordPressCreation = () => {
  const [showForm, setShowForm] = useState(true);
  const [createdSiteInfo, setCreatedSiteInfo] = useState({name: null, url: null});
  const [creationError, setCreationError] = useState(null);

  const createWordPress = async newSiteData => {
    setCreationError(null);
    try {
      await httpClient.post('/api/wordpress/sites', newSiteData, {handleErrorsCentrally: false});
      setCreatedSiteInfo({
        name: newSiteData.name,
        url: new URL(`https://${newSiteData.name}${wordpressSubdomain}`),
      });
      setShowForm(false);
    } catch (err) {
      let creationErrorMessage = '';
      if (err.response.data.errors) {
        creationErrorMessage += ' ' + JSON.stringify(err.response.data.errors.json);
      }
      if (err.response.data.error) {
        creationErrorMessage += ' ' + err.response.data.error;
      }
      setCreationError(creationErrorMessage);
    }
  };

  return (
    <Grid centered>
      <Grid.Column className={styles.WordPressCreation}>
        <Container>
          <Header as="h3" className={styles.Header}>
            <Image src={wordpressIconDark} alt="wordpress icon" className={styles.HeaderIcon} />{' '}
            Creating a WordPress site
          </Header>
          {showForm ? (
            <div>
              <p>You're minutes away from getting your site up and running.</p>
            </div>
          ) : (
            <div>
              <p>The site has been created.</p>
              <p>
                It may take a few minutes until it is available due to the DNS propagation delay.
              </p>
              <p>
                You can then check how it looks:{' '}
                <a href={createdSiteInfo.url}>{createdSiteInfo.url.toString()}</a>.
              </p>
              <p>
                You can also further{' '}
                <Link to={`wordpress/${createdSiteInfo.name}`}>configure your site</Link>.
              </p>
            </div>
          )}
        </Container>
        {creationError && (
          <Message negative>
            <Message.Header>There was a problem creating the WordPress site</Message.Header>
            <p>{creationError}</p>
            <p>
              Please try again or open a{' '}
              <a
                href="https://cern.service-now.com/service-portal?id=service_element&name=web-portal"
                target="_blank"
                rel="noreferrer"
              >
                ticket
              </a>
            </p>
          </Message>
        )}
        {showForm && <WordPressCreationForm create={createWordPress} />}
      </Grid.Column>
    </Grid>
  );
};

export default WordPressCreation;
